import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { Currency } from "../app/Currencies/model";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function mergeRefs<T>(...refs: React.Ref<T>[]) {
  return (value: T) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref) {
        (ref as React.MutableRefObject<T | null>).current = value;
      }
    });
  };
}

export function range(start: number, end: number) {
  return Array.from({ length: end - start }, (_, i) => start + i);
}

export async function copyToClipboard(text: string) {
  try {
    await navigator.clipboard.writeText(text);
  } catch (err) {
    console.error("Failed to copy: ", err);
  }
}

export const calculateCurrencyPrice = (toCurrency: Currency, fromCurrency: Currency, amount: number) => {
  if (!toCurrency || !fromCurrency || !amount) return 0;
  const rate = toCurrency?.rate / fromCurrency?.rate;
  const price = roundWithPrecision(amount * rate, toCurrency?.precisionDigits);
  return price;
};

function roundWithPrecision(value: number, precision: number) {
  return Math.round(value * Math.pow(10, -precision)) / Math.pow(10, -precision);
}

export function arrayLast<T>(array: T[]): T | undefined {
  return array[array.length - 1];
}

export function unwrapError<T>(fn: () => T, def: T): T {
  try {
    return fn();
  } catch (e) {
    return def;
  }
}
